<p-table [value]="currentProtections">
  <ng-template pTemplate="header">
    <tr>
      <th i18n>Couverture</th>
      <th i18n>Conserver ou remplacer</th>
      <th i18n>Type</th>
      <th i18n>Date de d'émission</th>
      <th i18n>Compagnie d'assurance vie</th>
      @if (!isReadOnly) {
        <th i18n>Action</th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-currentProtection let-i="rowIndex">
    <tr>
      <td>{{ (currentProtection.coverageAmount | emAmount: 'noDecimal') || '--' }}</td>
      <td
        >{{
          currentProtection.isReplacing !== null && currentProtection.isReplacing !== undefined
            ? translate.getTranslation(currentProtection.isReplacing)
            : '--'
        }}
      </td>
      <td>{{ currentProtection.coverageType ? currentProtection.coverageType : '--' }}</td>
      <td>{{ currentProtection.issueDate ? (currentProtection.issueDate | emDate) : '--' }}</td>
      <td>{{ currentProtection.issuerName ? currentProtection.issuerName : '--' }}</td>

      @if (!isReadOnly) {
        <td>
          <p-button
            (mousedown)="modifyProtection(i)"
            i18n-label
            class="action__button"
            label="Modifier"
            icon="pi pi-pencil"
            iconPos="left"></p-button>
          <p-button
            (mousedown)="deleteProtection(i)"
            i18n-label
            class="action__button"
            label="Supprimer"
            icon="pi pi-trash"
            iconPos="left"></p-button>
        </td>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage" let-columns>
    <p class="pt-5"><i i18n>Aucune protection existante</i></p>
  </ng-template>
</p-table>

<p-button
  [class.visibility--hidden]="isReadOnly"
  class="flex justify-content-end margin--top-medium"
  (onClick)="displayDialog()"
  i18n-label
  label="Ajouter une protection existante"
  icon="pi pi-plus"></p-button>

<p-dialog
  class="dialog"
  [modal]="true"
  [dismissableMask]="true"
  [(visible)]="showDialog"
  (onHide)="resetForms()">
  <h2 i18n>Ajout d'une protection existante</h2>

  <div>
    <div class="flex justify-content-around">
      <div class="flex">
        <p-radioButton name="product" [value]="false" [(ngModel)]="isEmmaProduct" inputId="otherProduct" />
        <label for="otherProduct" class="ml-2" i18n>Autre produit</label>
      </div>

      <div class="flex">
        <p-radioButton name="product" [value]="true" [(ngModel)]="isEmmaProduct" inputId="emmaProduct" />
        <label for="emmaProduct" class="ml-2" i18n>Produit Emma</label>
      </div>
    </div>

    <p-divider></p-divider>

    @if (!isEmmaProduct) {
      <form [formGroup]="otherProductForm">
        <label class="dialog__text mb-2" for="coverageAmount" i18n>Montant total de l'assurance vie</label>
        <input
          [ngClass]="{
            'error--input':
              otherProductForm.controls.coverageAmount.invalid &&
              otherProductForm.controls.coverageAmount.touched,
          }"
          [maxlength]="17"
          [thousandSeparator]="isFr ? ' ' : ','"
          [prefix]="otherProductForm.controls.coverageAmount.value && !isFr ? '$' : ''"
          [suffix]="isFr ? ' $' : ''"
          [formControl]="otherProductForm.controls.coverageAmount"
          mask="separator.0"
          i18n-placeholder
          placeholder="Montant total de l'assurance vie"
          id="coverageAmount"
          pInputText />
        <label class="dialog__text mb-2" i18n>Conserver ou remplacer</label>
        <p-dropdown
          [options]="replacePolicyOptions | emTranslate | emFilterDropdownOptions: replaceInsurance.UNKNOWN"
          i18n-placeholder
          placeholder="Choisir"
          [formControl]="otherProductForm.controls.isReplacing"
          optionLabel="name"
          optionValue="value"></p-dropdown>
        <label class="dialog__text mb-2" for="coverageType" i18n>Type de contrat (optionnel)</label>
        <input
          [ngClass]="{
            'error--input':
              otherProductForm.controls.coverageType.invalid &&
              otherProductForm.controls.coverageType.touched,
          }"
          [formControl]="otherProductForm.controls.coverageType"
          id="coverageType"
          i18n-placeholder
          placeholder="Type de contrat"
          type="text"
          pInputText />
        <label class="dialog__text mb-2" for="issueDate" i18n>Date d'émission (optionnel)</label>
        <input
          [ngClass]="{
            'error--input':
              otherProductForm.controls.issueDate.invalid && otherProductForm.controls.issueDate.touched,
          }"
          [formControl]="otherProductForm.controls.issueDate"
          id="issueDate"
          i18n-placeholder
          placeholder="JJ/MM/AAAA"
          type="text"
          mask="d0/M0/0000"
          [dropSpecialCharacters]="false"
          pInputText />
        <label class="dialog__text mb-2" for="issuerName" i18n
          >Nom de la compagnie d'assurance (optionnel)</label
        >
        <input
          [ngClass]="{
            'error--input':
              otherProductForm.controls.issuerName.invalid && otherProductForm.controls.issuerName.touched,
          }"
          [formControl]="otherProductForm.controls.issuerName"
          id="issuerName"
          i18n-placeholder
          placeholder="Nom de la compagnie d’assurance"
          type="text"
          pInputText />
        <p-button
          (onClick)="confirm()"
          [disabled]="otherProductForm.invalid"
          class="dialog__button"
          i18n-label
          label="Soumettre"
          icon="pi pi-pencil"
          iconPos="left"></p-button>
      </form>
    }
    @if (isEmmaProduct) {
      <form [formGroup]="emmaProductForm">
        <label class="dialog__text mb-2" i18n>Numéro de police</label>
        <!--      TODO use iconField loading animation when we upgrade primeng https://primeng.org/iconfield-->
        <input
          [ngClass]="{'border-green-500': currentProtectionFound}"
          [formControl]="emmaProductForm.controls.policyNumber"
          i18n-placeholder
          placeholder="Numéro de police"
          pInputText />
        <label class="dialog__text mb-2" i18n>Conserver ou remplacer</label>
        <p-dropdown
          [options]="replacePolicyOptions | emTranslate | emFilterDropdownOptions: replaceInsurance.UNKNOWN"
          i18n-placeholder
          placeholder="Choisir"
          [formControl]="emmaProductForm.controls.isReplacing"
          optionLabel="name"
          optionValue="value"></p-dropdown>
        <label class="dialog__text mb-2" i18n>Montant total de l'assurance vie</label>
        <input
          [thousandSeparator]="isFr ? ' ' : ','"
          [prefix]="emmaProductForm.controls.coverageAmount.value && !isFr ? '$' : ''"
          [suffix]="isFr ? ' $' : ''"
          [formControl]="emmaProductForm.controls.coverageAmount"
          mask="separator.0"
          i18n-placeholder
          placeholder="-- $"
          pInputText />
        <label class="dialog__text mb-2" i18n>Date d'émission</label>
        <input
          [formControl]="emmaProductForm.controls.issueDate"
          mask="d0/M0/0000"
          i18n-placeholder
          placeholder="JJ/MM/AAAA"
          pInputText />
        <label class="dialog__text mb-2" i18n>Nom de la compagnie d'assurance</label>
        <input [formControl]="emmaProductForm.controls.issuerName" pInputText />
        <p-button
          (onClick)="confirm()"
          [disabled]="emmaProductForm.invalid || !currentProtectionFound"
          class="dialog__button"
          i18n-label
          label="Ajouter la protection existante"
          icon="pi pi-plus"
          iconPos="left"></p-button>
      </form>
    }
  </div>
</p-dialog>
